<template>
    <b-modal
        id="ModalEditProjectUser"
        size="md"
        title="Modifier un utilisateur du projet"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <div v-if="user">
            <b-form-group label="Utilisateur">
                {{ user.firstName }}
                <span class="text-uppercase">{{ user.lastName }}</span>
            </b-form-group>
            <b-form-group label="Rôle">
                <b-form-input
                    v-model="user.ProjectUser.role"
                    list="role-list"
                    autocomplete="off"
                    placeholder="Selectionner ou saisir l'intitulé du rôle"
                    :state="isRoleValid"
                    required
                />
                <datalist id="role-list">
                    <option v-for="r in roleList" :key="r" :value="r">
                        {{ r }}
                    </option>
                </datalist>
            </b-form-group>

            <b-form-group label="Niveau de droits">
                <b-form-select v-model="user.ProjectUser.credentials">
                    <b-form-select-option :value="1">
                        Visibilité
                    </b-form-select-option>
                    <b-form-select-option :value="5">
                        Modification
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-button
                class="d-block mx-auto mt-3"
                variant="kalkin-2"
                :disabled="!isRoleValid"
                @click="save"
            >
                Associer
            </b-button>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: {
        projectId: { type: [String, Number], required: true },
        user: { type: Object, required: false },
    },

    data: function() {
        return {
            roleList: [
                "Chef de Projet",
                "Commercial",
                "Gestion des données",
                "Gestion de l'application",
                "Designer",
                "Développeur",
                "Testeur",
                "Porteur de projet",
                "Client",
                "Agent d'accueil",
                "Responsable",
                "Stagiaire",
            ],
            credentials: {
                role: "",
                value: 1,
            },
        };
    },

    computed: {
        isRoleValid() {
            return (
                this.user &&
                this.user.ProjectUser &&
                this.user.ProjectUser.role !== ""
            );
        },
    },

    methods: {
        async save() {
            await this.$store.dispatch("project/editUser", {
                projectId: this.projectId,
                userId: this.user.id,
                role: this.user.ProjectUser.role,
                credentials: this.user.ProjectUser.credentials,
            });
            this.$bvModal.hide("ModalEditProjectUser");
            this.$emit("saved");
        },
    },
};
</script>
